import React from "react"
import AdSense from "react-adsense"

const MyAdSense = () => (
  <AdSense.Google client="ca-pub-4632341699833963" slot="1753680896" />
)

export default MyAdSense
